import React from 'react'
import TooltipSimple from '../tooltips/TooltipSimple';

const itemsDefault = [
  {
      'title': 'view_card',
      'slug': 'block',
      'icon': 'fa-regular fa-table-rows'
  },
  {
      'title': 'view_simple',
      'slug': 'list',
      'icon': 'fa-solid fa-list'
  },
  {
    'title': 'view_stats',
    'slug': 'stats',
    'icon': 'fa-regular fa-chart-simple'
  },
  {
      'title': 'view_pipeline',
      'slug': 'pipeline',
      'icon': 'fa-regular fa-square-kanban'
  },
  {
      'title': 'view_calendar',
      'slug': 'calendar',
      'icon': 'fa-regular fa-calendar'
  }
];

export default function ButtonsViews(props){
	const {
        items = itemsDefault, 
        value, 
        handleChange
    } = props

	return (
		<>
      {
      items.map((e, index) =>
        <span key={index}>
            <TooltipSimple title={(e.title).trad()}>
                <button
                    onClick={() => handleChange(e.slug)}
                    className={(value != e.slug ? "text-gc-light-blue-dark" : "text-gc-dark-blue") + " btn btn-lg btn-link btn-view p-0 ml-3"}  
                >
                    <i className={e.icon}></i>
                </button>                
            </TooltipSimple>
        </span>)
      } 
    </>
	);
}